import {Role} from "../api/accessControl/Role.ts";

type QuinnAccessUser = {
    role: Role
    flags?: { getFlag(key: string): boolean } | null
}

export function canUseQuinn(user: QuinnAccessUser | null): boolean {
    return Boolean(user && user.role === Role.Partner && user.flags?.getFlag('PARTNER__CAN_SEE_QUINN'))
}
